<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">Our Testimonials</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/testimonials" class="h5 text-white">Our Testimonials</a>
        </div>
    </div>
</div>

<!-- Testimonial Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="section-title text-center position-relative pb-3 mb-4 mx-auto" style="max-width: 600px;">
            <h5 class="fw-bold text-primary text-uppercase">Testimonials</h5>
            <h1 class="mb-0">What Our Clients Say About Working With Us</h1>
        </div>
        <owl-carousel-o [options]="testimonialCarousel" class="owl-btn-center-lr testimonial-carousel mrt-80">
          <ng-template carouselSlide *ngFor="let client of clients">
            <!-- Testimonial box -->
            <div class="testimonial-item bg-light">
                <div class="d-flex align-items-center border-bottom pt-5 pb-4 px-5">
                    <img class="img-fluid border-radius" src="assets/images/{{client.image}}"
                        style="width: 60px; height: 60px;" alt="client-1">
                    <div class="ps-4">
                        <h4 class="text-primary mb-1">{{client.title}}</h4>
                        <small class="text-uppercase">{{client.subtitle}}</small>
                    </div>
                </div>
                <div class="pt-4 pb-5 px-5">
                    {{client.desc}}
                </div>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div>
<!-- Testimonial End -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->